import { z } from 'zod';

/**
 * Минимальный пользователь, который гарантированно возвращает
 * GET /api/v3/users/self для любой роли (player / coach / admin).
 * Приложения расширяют схему своими полями через .extend().
 */
export const BaseSelfUserSchema = z
  .object({
    id: z.number(),
    username: z.string(),
    slug: z.string(),
    timezone: z.string(),
    language: z.string(),
  })
  .passthrough();

export type BaseSelfUser = z.infer<typeof BaseSelfUserSchema>;

export interface Credentials {
  username: string;
  password: string;
}
